module.exports = (require("./helpers/browser/import-polyfill")(parcelRequire.resolve("eRzc9"))).then(() => parcelRequire('zgFOA'));